module.exports = __webpack_public_path__ + "static/flags/KN-426e7aa17060cff8c33a3cd9478deecc.gif";